// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-select {
  position: relative;
  min-width: 212px;
  max-width: 700px;
  font-family: Arial, sans-serif;
}
.multi-select .select-box {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  padding: 0.1rem 0.3rem;
  border-radius: 3px;
  min-height: 30px;
  cursor: pointer;
  background-color: #fff;
  flex: 5 1;
}
.multi-select .select-box input {
  border: none;
  outline: none;
  width: 100%;
  padding: 0.3rem 0rem;
}
.multi-select .select-box .chip {
  background: #4a90e2;
  color: white;
  padding: 0.2rem 0.3rem;
  margin: 0.1rem 0.2rem;
  border-radius: 2px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.multi-select .select-box .chip .close {
  cursor: pointer;
  font-weight: bold;
}
.multi-select .dropdown {
  position: absolute;
  width: 100%;
  background: white;
  border: 0.1px solid #ccc;
  border-radius: 3px;
  max-height: 500px;
  overflow-y: auto;
  z-index: 100;
}
.multi-select .dropdown .option {
  padding: 0.6rem;
  border-bottom: 0.1px solid #ccc;
  cursor: pointer;
  text-align: left;
}
.multi-select .dropdown .option:hover {
  background: #4a90e2;
  color: white;
}
.multi-select .dropdown .option.selected {
  background: #4a90e2;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/base/MultiSelect.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EAEA,gBAAA;EAEA,8BAAA;AADJ;AAGI;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;AADN;AAGM;EACE,YAAA;EACA,aAAA;EAGA,WAAA;EACA,oBAAA;AAHR;AAMM;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAJR;AAMQ;EACE,eAAA;EACA,iBAAA;AAJV;AASI;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAPN;AASM;EACE,eAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAPR;AASQ;EACE,mBAAA;EACA,YAAA;AAPV;AAUQ;EACE,mBAAA;EACA,YAAA;AARV","sourcesContent":[".multi-select {\n    position: relative;\n    min-width: 212px;\n    // width: 100%;\n    max-width: 700px;\n    // margin-left:0.5rem;\n    font-family: Arial, sans-serif;\n  \n    .select-box {\n      display: flex;\n      flex-wrap: wrap;\n      border: 1px solid #ccc;\n      padding: 0.1rem 0.3rem;\n      border-radius: 3px;\n      min-height: 30px;\n      cursor: pointer;\n      background-color: #fff;\n      flex:5;\n  \n      input {\n        border: none;\n        outline: none;\n        // flex: 1;\n        // border:0.1px solid #ccc;\n        width: 100%;\n        padding: 0.3rem 0rem;\n      }\n  \n      .chip {\n        background: #4a90e2;\n        color: white;\n        padding: 0.2rem 0.3rem;\n        margin: 0.1rem 0.2rem;\n        border-radius: 2px;\n        display: flex;\n        align-items: center;\n        gap: 5px;\n  \n        .close {\n          cursor: pointer;\n          font-weight: bold;\n        }\n      }\n    }\n  \n    .dropdown {\n      position: absolute;\n      width: 100%;\n      background: white;\n      border: 0.1px solid #ccc;\n      border-radius: 3px;\n      max-height: 500px;\n      overflow-y: auto;\n      z-index: 100;\n  \n      .option {\n        padding: 0.6rem;\n        border-bottom: 0.1px solid #ccc;\n        cursor: pointer;\n        text-align: left;\n  \n        &:hover {\n          background: #4a90e2;\n          color: white;\n        }\n  \n        &.selected {\n          background: #4a90e2;\n          color: white;\n        }\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
